import React from 'react'
import { Col, Form, FormGroup, Label, Input, Row, FormFeedback } from 'reactstrap';

export const FormMicSiteArea = (props) => {

    const {
        closeDialog, loading, handleInputChange,
        validaciones, methodAction,
        id_mic_site, name, button, sites,
    } = props;
    const {
        id_mic_site_valid, name_valid,
    } = validaciones;

    //////console.log(sites,"UwU");
    return (
        <Form className="" role="form" >

            <Row>
                <Col md="12">
                    <FormGroup>
                        <Label className="col-form-label">Sitio <span className='f-16' style={{ color: "#0079C7" }}>*</span></Label>
                        <Input
                            className="form-control form-control-sm input-air-primary"
                            type="select"
                            name="id_mic_site"
                            value={id_mic_site}
                            onChange={handleInputChange}
                            options={sites}
                            invalid={id_mic_site_valid}
                            style={{
                                fontSize: "13px",
                                borderRadius: "8px",
                                border: "1px solid #007bff",
                                padding: "8px 12px",
                                height: "34px",
                                boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
                                transition: "all 0.2s ease",
                                outline: "none"
                            }}
                        //noOptionsMessage={()=>"Sin opciones"}
                        >
                            <option defaultValue={0}>Selecciona una opción</option>
                            {
                                sites.map(element => {
                                    return (
                                        <option key={element.id_mic_site} value={element.id_mic_site}>{element.name}</option>
                                    )
                                })
                            }
                        </Input>
                        {/* <FormText color='danger' hidden={!areas_valid}>Debes seleccionar almenos una opción</FormText> */}
                        <FormFeedback>Selecciona una opción</FormFeedback>
                    </FormGroup>
                </Col>
                <Col sm="12">
                    <FormGroup>
                        <Label className="col-form-label">Nombre <span className='f-16' style={{ color: "#0079C7" }}>*</span></Label>
                        <Input
                            type="text"
                            className="form-control form-control-sm input-air-primary"
                            name="name"
                            onChange={handleInputChange}
                            value={name}
                            autoComplete="off"
                            invalid={name_valid}
                            style={{
                                fontSize: "13px",
                                borderRadius: "8px",
                                border: "1px solid #007bff",
                                padding: "8px 12px",
                                height: "34px",
                                boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
                                transition: "all 0.2s ease",
                                outline: "none"
                            }}
                        />
                        <FormFeedback>Minimo 3 caracteres</FormFeedback>
                    </FormGroup>
                </Col>
            </Row>


        </Form>
    )
}
